import React, { Component } from 'react';
// import VkAuth from 'react-vk-auth';
// import FbAuth from 'react-facebook-login/dist/facebook-login-render-props'
// import TwitterLogin from 'react-twitter-auth'
// import OkAuth from '../../components/react-ok-auth'
import { sendEvent } from '../../helpers/analytics'

import {BASE_URL} from "../../config";


class Auth extends Component {
  handleVkResponse = (data) => {
    console.log(data)
  }
  render () {
    return (
      <div className="test__start">
        <h1 className="h1 h1--start">тест на скорость</h1>
        <div className="start__text">
          <p>Для того, чтобы участвовать в конкурсе и получить сертификат на тест-драйв от Porsche, вам необходимо авторизоваться в одной из соцсетей.</p>
        </div>
        <div className="start__social">



          {/*
          <VkAuth apiId="6634494" callback={this.handleVkResponse} >
            <img src="/images/social/vk.svg" alt="facebook"/>
          </VkAuth>
          <FbAuth
            appId="217670992109845"
            autoLoad={true}
            fields="name,email,picture"
            onClick={() => {console.log('clicked')}}
            callback={this.handleVkResponse}
            render={renderProps => (
              <button onClick={renderProps.onClick}>
                <img src="/images/social/facebook.svg" alt="facebook"/>
              </button>
            )}
          />

          <TwitterLogin loginUrl="http://localhost:4000/api/v1/auth/twitter"
                        onFailure={this.handleVkResponse}
                        onSuccess={this.handleVkResponse}
                        requestTokenUrl="http://localhost:3000/api/v1/auth/twitter/reverse"
                        >
            <img src="/images/social/twitter.svg" alt="twitter"/>
          </TwitterLogin>

          <OkAuth clientId={'1268797184'} scope={'VALUABLE_ACCESS;LONG_ACCESS_TOKEN'} redirectUri={window.location.href + '?test=true'} >
            <img src="/images/social/ok.svg" alt="ok"/>
          </OkAuth>
          */}

          <a href={`${BASE_URL}/auth/vk-oauth2/`} onClick={() => sendEvent('game', 'click', 'vk')}>
            <img src="/images/social/vk.svg" alt="vk"/>
          </a>

          <a href={`${BASE_URL}/auth/facebook/`}>
            <img src="/images/social/facebook.svg" alt="facebook"/>
          </a>

          <a href={`${BASE_URL}/auth/twitter/`} onClick={() => sendEvent('game', 'click', 'twitter')}>
            <img src="/images/social/twitter.svg" alt="twitter"/>
          </a>

          <a href={`${BASE_URL}/auth/odnoklassniki-oauth2/`} onClick={() => sendEvent('game', 'click', 'ok')}>
            <img src="/images/social/ok.svg" alt="ok"/>
          </a>

        </div>
      </div>
    )
  }
}

export default Auth


// WEBPACK FOOTER //
// ./src/pages/test/auth.js